import type {
  PaymentResponseDto,
  StripeConnectionResponseDto,
  StripeOnboardingResponseDto,
  StripePaymentUrlResponseDto,
} from '@trellis/api'

import { apiClient } from '@/lib/api-client'
import { request } from '@/lib/request'

export const getStripeConnectionStatus = () =>
  request<StripeConnectionResponseDto | null>(() =>
    apiClient.api.stripeControllerGetConnectionStatus(),
  )

export const startStripeOnboarding = () =>
  request<StripeOnboardingResponseDto>(() =>
    apiClient.api.stripeControllerStartOnboarding(),
  )

export const refreshStripeConnection = () =>
  request<{ status: string }>(() => apiClient.api.stripeControllerRefreshConnection())

export const disconnectStripe = () =>
  request<void>(() => apiClient.api.stripeControllerDisconnect())

export const getPaymentUrl = (invoiceId: string) =>
  request<StripePaymentUrlResponseDto>(() =>
    apiClient.api.stripeControllerGetPaymentUrl({ invoiceId }),
  )

export const listInvoicePayments = (invoiceId: string) =>
  request<PaymentResponseDto[]>(() =>
    apiClient.api.stripeControllerListPayments({ invoiceId }),
  )

export type { StripeConnectionResponseDto as StripeConnectionResponse }
